<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import Dropdown, { type DropdownItems } from '../Dropdown.vue';

const dob = defineModel('dob', {
  required: true,
});

const dayOptions = computed<DropdownItems[]>(() =>
  Array.from({ length: 31 }, (_, i) => ({
    name: (i + 1).toString().padStart(2, '0'),
    value: (i + 1).toString().padStart(2, '0'),
  }))
);

const monthOptions = computed<DropdownItems[]>(() =>
  Array.from({ length: 12 }, (_, i) => ({ name: (i + 1).toString().padStart(2, '0'), value: (i + 1).toString().padStart(2, '0') }))
);

const yearOptions = computed<DropdownItems[]>(() =>
  Array.from({ length: new Date().getFullYear() - 1900 + 1 }, (_, i) => ({
    name: (1900 + i).toString(),
    value: (1900 + i).toString(),
  })).reverse()
);

const day = ref<number>(0);
const month = ref<number>(0);
const year = ref<number>(0);

watch([() => month.value, () => day.value], () => {
  const currentDay = day.value;
  const lastDayOfMonth = new Date(year.value ?? new Date().getFullYear(), month.value, 0).getDate();

  if (currentDay > lastDayOfMonth) {
    day.value = 0;
  }
});

watch([() => day.value, () => month.value, () => year.value], () => {
  if (day.value > 0 && month.value > 0 && year.value > 0) {
    dob.value = `${year.value}-${month.value}-${day.value}`;
  }
});
</script>

<template>
  <div class="block__wrap">
    <Dropdown input-class="date-input" placeholder="DD" v-model:value="day" :options="dayOptions">
    </Dropdown>
    <Dropdown input-class="date-input" placeholder="MM" v-model:value="month" :options="monthOptions">
    </Dropdown>
    <Dropdown input-class="date-input" placeholder="JJJJ" v-model:value="year" :options="yearOptions">
    </Dropdown>
  </div>
</template>

<style>
.date-input {
  border: 1px solid var(--gray-alt);
}
</style>
